import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sprout } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="not-found">
      <div className="font-mono text-[10px] tracking-[0.3em] uppercase mb-4" style={{color:"var(--gold)"}}>Error 404</div>
      <h1 className="font-display text-7xl md:text-9xl tracking-tighter mb-6" style={{color:"var(--text)"}}>Off-grid.</h1>
      <p className="text-lg mb-8 max-w-md mx-auto" style={{color:"var(--text-2)"}}>
        This page wasn't found in our genetics catalog. It may have been removed, or the link was mistyped.
      </p>
      <div className="flex justify-center gap-3 flex-wrap">
        <Link to="/" className="btn-primary">Back to marketplace <ArrowRight className="w-4 h-4"/></Link>
        <Link to="/browse" className="btn-outline"><Sprout className="w-4 h-4 inline mr-1"/>Browse genetics</Link>
      </div>
    </div>
  );
}
